function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.5 6a2.5 2.5 0 01-4.786 1.013A3 3 0 0013 10v4a5 5 0 01-4.704 4.991 2.5 2.5 0 11-.01-2.005A3 3 0 0011 14v-4a5 5 0 014.704-4.991A2.5 2.5 0 0120.5 6z",
  fill: "currentColor"
});

function SvgRoute(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMC41IDZDMjAuNSA3LjM4MDcxIDE5LjM4MDcgOC41IDE4IDguNUMxNi45ODAxIDguNSAxNi4xMDI4IDcuODg5MjIgMTUuNzE0IDcuMDEzNDZDMTQuMTkxMyA3LjE1NzQ5IDEzIDguNDM5NjMgMTMgMTBWMTJWMTRDMTMgMTYuNjYyMSAxMC45MTk1IDE4LjgzODQgOC4yOTU3MiAxOC45OTE0QzcuOTExOTIgMTkuODc4OSA3LjAyODQ5IDIwLjUgNiAyMC41QzQuNjE5MjkgMjAuNSAzLjUgMTkuMzgwNyAzLjUgMThDMy41IDE2LjYxOTMgNC42MTkyOSAxNS41IDYgMTUuNUM3LjAxOTk0IDE1LjUgNy44OTcyMyAxNi4xMTA4IDguMjg2MDUgMTYuOTg2NUM5LjgwODczIDE2Ljg0MjUgMTEgMTUuNTYwNCAxMSAxNFYxMlYxMEMxMSA3LjMzNzg1IDEzLjA4MDUgNS4xNjE2MyAxNS43MDQzIDUuMDA4NkMxNi4wODgxIDQuMTIxMDYgMTYuOTcxNSAzLjUgMTggMy41QzE5LjM4MDcgMy41IDIwLjUgNC42MTkyOSAyMC41IDZaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };